module.exports = __webpack_public_path__ + "static/media/tooltip-default.0a89c667.svg";